export default "__VITE_ASSET__DeVVixws__"